<!-- Upload Summary Bar -->
@if (activeUploadsCount() > 0 || alertsCount() > 0) {
  <div class="upload-summary">
    <div class="upload-stats">
      @if (activeUploadsCount() > 0) {
        <span class="stat active">
          <fa-duotone-icon [icon]="faCloudArrowUp"></fa-duotone-icon>
          {{ activeUploadsCount() }} {{ activeUploadsCount() | l10nPlural: 'upload.active' }}
        </span>
      }
      @if (alertsCount() > 0) {
        <span class="stat alerts">
          <fa-duotone-icon [icon]="faExclamationTriangle"></fa-duotone-icon>
          {{ alertsCount() }} {{ alertsCount() | l10nPlural: 'upload.conflicts' }}
        </span>
      }
    </div>

    <div class="upload-actions">
      @if (hasAlerts()) {
        <button pButton type="button"
          class="p-button-text p-button-sm action-btn"
          (click)="renameAll()"
          [pTooltip]="'upload.renameAll' | translate"
          tooltipPosition="bottom">
          <fa-duotone-icon [icon]="faRotate"></fa-duotone-icon>
        </button>
        <button pButton type="button"
          class="p-button-text p-button-sm action-btn"
          (click)="newVersionForAll()"
          [pTooltip]="'upload.newVersionAll' | translate"
          tooltipPosition="bottom">
          <fa-duotone-icon [icon]="faCodeBranch"></fa-duotone-icon>
        </button>
      }
      @if (canCancelAny()) {
        <button pButton type="button"
          class="p-button-text p-button-sm cancel-all-btn"
          (click)="cancelAll()">
          {{ 'upload.cancelAll' | translate }}
        </button>
      }
    </div>
  </div>
}

<!-- Upload List -->
<div class="upload-list">
  <!-- The resumable-uploads read failed: a face with Try again FIRST in the chain — "no active
       uploads" is a landed answer, and this read never landed (a member told nothing would
       re-upload from zero). Batches the member started meanwhile still list below it. -->
  @if (resumableLoadFailed()) {
    <app-load-failed [compact]="true" [message]="'upload.resumableLoadFailed' | translate" [retrying]="resumableReloading()" (retry)="retryResumable()"/>
  } @else if (batches().length === 0) {
    <div class="empty-state">
      <fa-duotone-icon [icon]="faCloudArrowUp" class="empty-icon"></fa-duotone-icon>
      <p>{{ 'upload.noActiveUploads' | translate }}</p>
    </div>
  }

  @for (batch of batches(); track trackByBatchId($index, batch)) {
    <div class="upload-batch" [class.collapsed]="batch.collapsed">
      <!-- Batch Header -->
      <div class="batch-header focus-ring" role="button" tabindex="0" [attr.aria-expanded]="!batch.collapsed"
           (click)="batch.collapsed = !batch.collapsed" (keydown.enter)="batch.collapsed = !batch.collapsed">
        <div class="batch-header-content">
          <!-- Top Row: Icon, Title, and Collapse Icon -->
          <div class="batch-header-top">
            <div class="batch-info">
              <fa-duotone-icon [icon]="getBatchIcon(batch)" class="batch-icon"></fa-duotone-icon>
              <span class="batch-title">{{ getBatchTitle(batch) }}</span>
            </div>
            <fa-duotone-icon 
              [icon]="batch.collapsed ? faChevronRight : faChevronDown" 
              class="collapse-icon">
            </fa-duotone-icon>
          </div>
          
          <!-- Bottom Row: Progress and Time Remaining -->
          @if (getActiveUploadsInBatch(batch) > 0) {
            <div class="batch-header-bottom">
              <div class="batch-progress-container">
                <p-progressBar
                  [value]="batch.progress"
                  [showValue]="false"
                  [style]="{'height': '4px', 'width': '100%'}">
                </p-progressBar>
                <div class="batch-progress-info">
                  <span class="progress-percent">{{ batch.progress }}%</span>
                  @if (getBatchTimeRemaining(batch); as timeRemaining) {
                    <span class="time-remaining">{{ timeRemaining }}</span>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      <!-- Batch Uploads -->
      @if (!batch.collapsed) {
        <div class="batch-uploads">
          @for (upload of batch.uploads; track trackByUploadId($index, upload)) {
            <app-upload-item 
              [upload]="upload"
              [batchId]="batch.id">
            </app-upload-item>
          }
        </div>
      }
    </div>
  }
</div>